import React from 'react';

import { CriteriaRender } from './CriteriaRender';
import { ProductConfigChanges } from '../../../../types';

interface ProductConfigRenderProps {
  changes: ProductConfigChanges;
}

export const ProductConfigRender = ({ changes }: ProductConfigRenderProps) => {
  if (!changes.criteria) return null;

  return (
    <CriteriaRender
      before={changes.criteria.before as Record<string, unknown> | null}
      after={changes.criteria.after as Record<string, unknown> | null}
    />
  );
};
